import {getTestProps, DataTestPropName, DataTestAttrs} from '@benchling/js-test-utils';

const DATA_TEST_PROP_KEYS = Object.values(DataTestPropName);

/**
 * Overwrite the test props on the element with the specified attrs, or remove
 * all test props if dataTestAttrs is unspecified.
 *
 * Unlike with getTestProps, it's common that this function will be called on
 * a long-lived element that may change test attr identity over the course of
 * its life, so it's important to reset the test attr state each time this is
 * called that we don't incorrectly leave around stale props.
 */
export default function setTestAttrs($el: JQuery, dataTestAttrs: DataTestAttrs | null | undefined): void {
  const testProps = dataTestAttrs ? getTestProps(dataTestAttrs) : {};
  for (const [key, val] of Object.entries(testProps)) {
    $el.attr(key, val);
  }
  // Remove any attrs that weren't explicitly specified.
  for (const key of DATA_TEST_PROP_KEYS.filter((key) => !testProps.hasOwnProperty(key))) {
    $el.removeAttr(key);
  }
}
